import { create, v, w } from '@dojo/framework/core/vdom';
import { icache } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

import { Store } from '@dojo/framework/stores/Store';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Messages, Bundle } from '@dojo/framework/i18n/i18n';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { LocalizedMessages } from '@dojo/framework/core/mixins/I18n';
// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';

import { Button } from '@dojo/widgets/button';
import { Radio } from '@dojo/widgets/radio';

import { quizPatternChangeProcess, userstate, createNlsMiddleware } from 'lcc-state';
import { quizidChange, quizstate } from '../support/state';

// import { logQuiz } from 'logger';

import { QuizMeta } from '../interfaces';

import css from '../css/quizfolder.m.css';

export interface WhichPathProperties {
	topicid: string;
	quizpatterns: { [key: string]: string };
	store: Store<QuizMeta>;
}

const nls = createNlsMiddleware('quiz');
const factory = create({ icache, nls, theme, quizstate, userstate }).properties<WhichPathProperties>();

export const WhichPath = factory(({ middleware: { icache, nls, theme, quizstate, userstate }, properties }) => {
	const { store, quizpatterns, topicid } = properties();
	quizstate.setStore(store);

	const {
		isPlaceholder,
		messages: { select_one, select: selectText }
	} = nls();

	if (isPlaceholder) {
		return null;
	}

	const choice = icache.get<string>('choice');
	const values: string[] = quizpatterns ? Object.keys(quizpatterns).sort() : [];

	const radios: DNode[] = values.map((value) => {
		return w(
			Radio,
			{
				key: value,
				checked: choice === value,
				value,
				name: 'quiz-select',
				onValue: (checked) => {
					checked && icache.set('choice', value);
				}
			},
			[{ label: quizpatterns[value] }]
		);
	});

	const themeCss = theme.classes(css);

	return v('div', { key: 'select-pattern' }, [
		v('fieldset', {}, [v('legend', {}, [select_one]), ...radios]),
		choice &&
			v('div', { classes: [themeCss.select] }, [
				w(
					Button,
					{
						onClick: () => {
							userstate.run(quizPatternChangeProcess)({ quizPattern: choice });
							quizstate.run(quizidChange)({ quizid: `${topicid}-${choice}` });
						}
					},
					[selectText]
				)
			])
	]);
});
